export default "__VITE_ASSET__BvdxHkYf__"